<!-- Dialog Template -->
<ng-template #dialogContent>
    <div class="polyline-dialog-content">

        <!-- Header Info -->
        <div class="header-info">
            <div class="form-group compact">
                <label class="form-label">İsim</label>
                <input type="text" class="form-input" [(ngModel)]="isim" placeholder="Polyline.X">
            </div>

            <!-- Aktif Body (kompakt) -->
            @if (!duzenleModu) {
            <div class="form-group compact aktif-body-group">
                <div class="body-header">
                    <label class="form-label">Body</label>
                    <label class="body-toggle mini">
                        <input type="checkbox" [(ngModel)]="aktifBodyeEkle">
                    </label>
                </div>
                @if (aktifBodyeEkle) {
                <div class="body-picker compact">
                    <input type="text" class="form-input body-input"
                           [value]="seciliAktifBodyIsim" readonly
                           [class.selecting]="bodySecModu">
                    <button class="pick-btn mini" [class.active]="bodySecModu"
                            (click)="bodySecBaslat()" title="Ürün ağacından seç">
                        <i class="crosshairs icon"></i>
                    </button>
                </div>
                }
            </div>
            }

            <div class="info-row">
                <span class="info-label">Nokta:</span>
                <span class="info-value">{{ noktalar.length }}</span>
                <span class="info-label">Uzunluk:</span>
                <span class="info-value">{{ toplamUzunluk }} mm</span>
            </div>
        </div>

        <!-- Tab Navigation -->
        <div class="tab-navigation">
            <button class="tab-btn" [class.active]="aktifTab === 'noktalar'" (click)="aktifTab = 'noktalar'" title="Noktalar">
                <i class="map marker alternate icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 'sekil'" (click)="aktifTab = 'sekil'" title="Şekil">
                <i class="shapes icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 'stil'" (click)="aktifTab = 'stil'" title="Stil">
                <i class="paint brush icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 'diger'" (click)="aktifTab = 'diger'" title="Diğer">
                <i class="cog icon"></i>
            </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">

            <!-- Noktalar Tab -->
            @if (aktifTab === 'noktalar') {
            <div class="tab-pane noktalar-pane">
                <!-- Kapalı toggle -->
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="kapali" (ngModelChange)="kapaliDegisti()">
                        Kapalı
                    </label>
                </div>

                <!-- Nokta listesi (kompakt) -->
                <div class="nokta-listesi">
                    @for (nokta of noktalar; track $index; let i = $index) {
                    <div class="nokta-item" [class.secili]="seciliNoktaIndex === i" [class.picking]="noktaSecModu === i" (click)="noktaDuzenleDialogAc(i)">
                        <button class="pick-btn nokta-pick" [class.active]="noktaSecModu === i"
                                (click)="noktaSecBaslat(i); $event.stopPropagation()" title="3D'den seç">
                            <i class="crosshairs icon"></i>
                        </button>
                        <span class="nokta-index">{{ i + 1 }}</span>
                        <span class="nokta-ozet">
                            {{ nokta.x | number:'1.0-1' }}, {{ nokta.y | number:'1.0-1' }}, {{ nokta.z | number:'1.0-1' }}
                        </span>
                        <div class="nokta-actions">
                            @if (i < noktalar.length - 1) {
                            <button class="btn-icon btn-tiny" title="Arasına ekle" (click)="arayaNoktaEkle(i); $event.stopPropagation()">
                                <i class="plus icon"></i>
                            </button>
                            }
                            <button class="btn-icon btn-tiny btn-danger" title="Sil" (click)="noktaSil(i); $event.stopPropagation()">
                                <i class="trash icon"></i>
                            </button>
                        </div>
                    </div>
                    }
                </div>

                <!-- Düzlem Seçimi (Matematiksel) -->
                <div class="duzlem-secimi">
                    <div class="duzlem-header">
                        <label>Düzlem</label>
                        <span class="duzlem-mini-ozet" [class.kamera-modu]="duzlemKameraTakip">
                            {{ duzlemKameraTakip ? 'Kamera' : (seciliYuzeyIsmi || 'Sabit') }}
                        </span>
                        <button class="pick-btn duzlem-kamera" [class.active]="duzlemKameraTakip"
                                (click)="duzlemKameraModuAc()" title="Kamera takip (serbest)">
                            <i class="video icon"></i>
                        </button>
                        <button class="pick-btn duzlem-pick" [class.active]="duzlemSecModu"
                                (click)="duzlemSecBaslat()" title="3D'den yüzey/düzlem seç">
                            <i class="crosshairs icon"></i>
                        </button>
                        <button class="pick-btn duzlem-ayar" [class.active]="duzlemAyarGoster"
                                (click)="duzlemAyarGoster = !duzlemAyarGoster" title="Düzlem parametreleri">
                            <i class="cog icon"></i>
                        </button>
                    </div>

                    @if (duzlemSecModu) {
                    <div class="duzlem-sec-info">
                        <i class="info circle icon"></i>
                        Yüzey seç. <strong>Sağ tık</strong> iptal.
                    </div>
                    }

                    @if (duzlemAyarGoster && !duzlemKameraTakip) {
                    <div class="duzlem-ayarlar">
                        <div class="duzlem-ozet">
                            <span class="duzlem-formul">
                                <span class="koef">{{ duzlemNormal.x | number:'1.2-2' }}</span>x +
                                <span class="koef">{{ duzlemNormal.y | number:'1.2-2' }}</span>y +
                                <span class="koef">{{ duzlemNormal.z | number:'1.2-2' }}</span>z +
                                <span class="koef">{{ duzlemD | number:'1.2-2' }}</span> = 0
                            </span>
                        </div>
                        <div class="normal-inputs">
                            <div class="coord-input">
                                <label>i</label>
                                <input type="number" [(ngModel)]="duzlemNormal.x" (ngModelChange)="duzlemGuncelle(false)" (blur)="noktalariDuzlemeProject()" step="0.1">
                            </div>
                            <div class="coord-input">
                                <label>j</label>
                                <input type="number" [(ngModel)]="duzlemNormal.y" (ngModelChange)="duzlemGuncelle(false)" (blur)="noktalariDuzlemeProject()" step="0.1">
                            </div>
                            <div class="coord-input">
                                <label>k</label>
                                <input type="number" [(ngModel)]="duzlemNormal.z" (ngModelChange)="duzlemGuncelle(false)" (blur)="noktalariDuzlemeProject()" step="0.1">
                            </div>
                            <div class="coord-input">
                                <label>d</label>
                                <input type="number" [(ngModel)]="duzlemD" (ngModelChange)="duzlemGuncelle(false)" (blur)="noktalariDuzlemeProject()" step="1">
                            </div>
                        </div>
                        <div class="duzlem-buttons">
                            <button class="btn-icon" (click)="duzlemNormalize()" title="Normalize">
                                <i class="sync icon"></i>
                            </button>
                            <button class="btn-icon" (click)="noktalariDuzlemeProject()" title="Düzleme yansıt">
                                <i class="compress arrows alternate icon"></i>
                            </button>
                            <button class="btn-icon btn-kamera" (click)="duzlemKameraModuAc()" title="Kamera moduna dön">
                                <i class="video icon"></i>
                            </button>
                        </div>
                    </div>
                    }

                    @if (duzlemAyarGoster && duzlemKameraTakip) {
                    <div class="duzlem-kamera-info">
                        <i class="video icon"></i>
                        Kamera yönünde serbest çizim
                    </div>
                    }
                </div>

                <!-- Nokta ekle butonları -->
                <div class="nokta-ekle-buttons">
                    <button class="btn-icon btn-add" (click)="noktaEkle()" title="Nokta ekle">
                        <i class="plus icon"></i>
                    </button>
                    <button class="btn-icon btn-add btn-3d" [class.active]="noktaSecModu === noktalar.length"
                            (click)="noktaSecBaslat(noktalar.length)" title="3D'den tek nokta ekle">
                        <i class="crosshairs icon"></i>
                    </button>
                    <button class="btn-icon btn-add btn-ardisik" [class.active]="ardisikTiklamaModu"
                            (click)="ardisikTiklamaToggle()"
                            [title]="ardisikTiklamaModu ? 'Ardışık modu durdur (sağ tık)' : 'Ardışık nokta ekle'">
                        <i class="mouse pointer icon"></i>
                    </button>
                </div>

                <!-- Ardışık mod bilgisi -->
                @if (ardisikTiklamaModu) {
                <div class="ardisik-info">
                    <i class="info circle icon"></i>
                    Tıkla = ekle. <strong>Sağ tık</strong> = bitir.
                </div>
                }
            </div>
            }

            <!-- Şekil Tab -->
            @if (aktifTab === 'sekil') {
            <div class="tab-pane sekil-pane">
                <!-- Hazır şekil seçimi (ikon butonlar) -->
                <div class="sekil-secim-grid">
                    <button class="sekil-btn" [class.active]="hazirSekil === 'serbest'"
                            (click)="hazirSekil = 'serbest'; hazirSekilDegisti()" title="Serbest Çizim">
                        <i class="pencil alternate icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'ucgen'"
                            (click)="hazirSekil = 'ucgen'; hazirSekilDegisti()" title="Üçgen">
                        <i class="caret up icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'kare'"
                            (click)="hazirSekil = 'kare'; hazirSekilDegisti()" title="Kare">
                        <i class="square icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'dikdortgen'"
                            (click)="hazirSekil = 'dikdortgen'; hazirSekilDegisti()" title="Dikdörtgen">
                        <i class="square outline icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'besgen'"
                            (click)="hazirSekil = 'besgen'; hazirSekilDegisti()" title="Beşgen">
                        <i class="star half icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'altigen'"
                            (click)="hazirSekil = 'altigen'; hazirSekilDegisti()" title="Altıgen">
                        <i class="stop icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'cokgen'"
                            (click)="hazirSekil = 'cokgen'; hazirSekilDegisti()" title="Çokgen (N kenar)">
                        <i class="clone outline icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'daire'"
                            (click)="hazirSekil = 'daire'; hazirSekilDegisti()" title="Daire">
                        <i class="circle icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'yildiz'"
                            (click)="hazirSekil = 'yildiz'; hazirSekilDegisti()" title="Yıldız">
                        <i class="star icon"></i>
                    </button>
                </div>

                @if (hazirSekil !== 'serbest') {
                <!-- Şekil parametreleri (dikey düzen) -->
                <div class="sekil-params-dikey">
                    <div class="param-row">
                        <label>X</label>
                        <input type="number" [(ngModel)]="sekilMerkezX" (ngModelChange)="sekilParametresiDegisti()" step="1">
                    </div>
                    <div class="param-row">
                        <label>Y</label>
                        <input type="number" [(ngModel)]="sekilMerkezY" (ngModelChange)="sekilParametresiDegisti()" step="1">
                    </div>
                    <div class="param-row">
                        <label>Z</label>
                        <input type="number" [(ngModel)]="sekilMerkezZ" (ngModelChange)="sekilParametresiDegisti()" step="1">
                    </div>
                    @if (hazirSekil === 'dikdortgen') {
                    <div class="param-row">
                        <label>G</label>
                        <input type="number" [(ngModel)]="sekilGenislik" (ngModelChange)="sekilParametresiDegisti()" min="1" step="10" title="Genişlik">
                    </div>
                    <div class="param-row">
                        <label>Yük</label>
                        <input type="number" [(ngModel)]="sekilYukseklik" (ngModelChange)="sekilParametresiDegisti()" min="1" step="10" title="Yükseklik">
                    </div>
                    } @else if (hazirSekil === 'yildiz') {
                    <div class="param-row">
                        <label>Dış</label>
                        <input type="number" [(ngModel)]="sekilYaricap" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="Dış Yarıçap">
                    </div>
                    <div class="param-row">
                        <label>İç</label>
                        <input type="number" [(ngModel)]="yildizIcYaricap" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="İç Yarıçap">
                    </div>
                    <div class="param-row">
                        <label>Kol</label>
                        <input type="number" [(ngModel)]="yildizKolSayisi" (ngModelChange)="sekilParametresiDegisti()" min="3" max="20" step="1" title="Kol Sayısı">
                    </div>
                    } @else if (hazirSekil === 'cokgen') {
                    <div class="param-row">
                        <label>R</label>
                        <input type="number" [(ngModel)]="sekilYaricap" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="Yarıçap (mm)">
                    </div>
                    <div class="param-row">
                        <label>N</label>
                        <input type="number" [(ngModel)]="cokgenKenarSayisi" (ngModelChange)="sekilParametresiDegisti()" min="3" step="1" title="Kenar Sayısı">
                    </div>
                    } @else if (hazirSekil === 'daire') {
                    <div class="param-row">
                        <label>R</label>
                        <input type="number" [(ngModel)]="sekilYaricap" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="Yarıçap (mm)">
                    </div>
                    <div class="param-row">
                        <label>T</label>
                        <input type="number" [(ngModel)]="tolerans" (ngModelChange)="toleransDegisti()" min="0.001" max="10" step="0.01" title="İşleme Toleransı (mm)">
                    </div>
                    <div class="param-row">
                        <label>
                            <input type="checkbox" [(ngModel)]="otomatikNoktaSayisi" (ngModelChange)="otomatikModDegisti()">
                            Oto
                        </label>
                        <input type="number" [(ngModel)]="daireNoktaSayisi" (ngModelChange)="sekilParametresiDegisti()" min="6" step="1" [disabled]="otomatikNoktaSayisi" title="Nokta Sayısı">
                    </div>
                    } @else {
                    <div class="param-row">
                        <label>R</label>
                        <input type="number" [(ngModel)]="sekilYaricap" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="Yarıçap">
                    </div>
                    }
                </div>
                }
            </div>
            }

            <!-- Stil Tab -->
            @if (aktifTab === 'stil') {
            <div class="tab-pane stil-pane">
                <div class="setting-row">
                    <label>Tip</label>
                    <select [(ngModel)]="cizgiTipi" (ngModelChange)="cizgiTipiDegisti()">
                        @for (tip of cizgiTipiSecenekleri; track tip.deger) {
                        <option [value]="tip.deger">{{ tip.etiket }}</option>
                        }
                    </select>
                </div>

                <div class="setting-row">
                    <label>Renk</label>
                    <input type="color" [(ngModel)]="renk" (ngModelChange)="renkDegisti()">
                </div>

                @if (cizgiTipi === 'Line2') {
                <div class="setting-row">
                    <label>Kalınlık</label>
                    <input type="range" [(ngModel)]="kalinlik" (ngModelChange)="kalinlikDegisti()" min="1" max="20" step="0.5">
                    <span class="value-display">{{ kalinlik }}</span>
                </div>
                }

                <div class="setting-row">
                    <label>Opaklık</label>
                    <input type="range" [(ngModel)]="opaklik" (ngModelChange)="opaklikDegisti()" min="0" max="1" step="0.1">
                    <span class="value-display">{{ opaklik }}</span>
                </div>

                <div class="setting-row">
                    <label>Stil</label>
                    <select [(ngModel)]="stil" (ngModelChange)="stilDegisti()">
                        @for (s of stilSecenekleri; track s.deger) {
                        <option [value]="s.deger">{{ s.etiket }}</option>
                        }
                    </select>
                </div>

                @if (stil === 'kesikli' || stil === 'kesikli-noktali') {
                <div class="setting-row">
                    <label>Kesik</label>
                    <input type="number" [(ngModel)]="kesikliBoyut" (ngModelChange)="stilDegisti()" min="1" max="50">
                </div>
                <div class="setting-row">
                    <label>Aralık</label>
                    <input type="number" [(ngModel)]="kesikliAralik" (ngModelChange)="stilDegisti()" min="1" max="50">
                </div>
                }

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="noktaGoster" (ngModelChange)="noktaGosterDegisti()">
                        Köşe noktaları
                    </label>
                </div>

                @if (noktaGoster) {
                <div class="setting-row">
                    <label>Boyut</label>
                    <input type="number" [(ngModel)]="noktaBoyutu" (ngModelChange)="noktaGosterDegisti()" min="1" max="20">
                </div>
                <div class="setting-row">
                    <label>Renk</label>
                    <input type="color" [(ngModel)]="noktaRengi" (ngModelChange)="noktaGosterDegisti()">
                </div>
                }
            </div>
            }

            <!-- Diğer Tab -->
            @if (aktifTab === 'diger') {
            <div class="tab-pane diger-pane">
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="enUstte" (ngModelChange)="enUsteDegisti()">
                        En üstte
                    </label>
                </div>
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="renderEt" (ngModelChange)="renderEtDegisti()">
                        Render et
                    </label>
                </div>
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="secilebilir" (ngModelChange)="secilebilirDegisti()">
                        Seçilebilir
                    </label>
                </div>
                <div class="setting-row">
                    <label>Katman</label>
                    <input type="number" [(ngModel)]="katman" min="0" max="31" step="1">
                </div>
                <div class="setting-row">
                    <button class="btn-icon btn-reset" (click)="sifirla()" title="Sıfırla">
                        <i class="redo icon"></i>
                    </button>
                </div>
            </div>
            }

        </div>

        <!-- Footer Actions -->
        <div class="dialog-footer">
            @if (duzenleModu) {
            <button class="btn-icon btn-primary" (click)="guncelle()" title="Güncelle">
                <i class="save icon"></i>
            </button>
            } @else {
            <button class="btn-icon btn-primary" (click)="olustur()" title="Oluştur">
                <i class="check icon"></i>
            </button>
            }
            <button class="btn-icon btn-secondary" (click)="kapat()" title="İptal">
                <i class="close icon"></i>
            </button>
        </div>

    </div>
</ng-template>

<!-- Koordinat Düzenleme Mini Dialog -->
@if (koordinatDialogAcik && koordinatDialogIndex !== null) {
<div class="koordinat-dialog-overlay" (click)="koordinatDialogKapat()">
    <div class="koordinat-dialog" (click)="$event.stopPropagation()">
        <div class="koordinat-header">
            <span>Nokta {{ koordinatDialogIndex + 1 }}</span>
            <button class="close-btn" (click)="koordinatDialogKapat()">
                <i class="close icon"></i>
            </button>
        </div>
        <div class="koordinat-content">
            <div class="coord-row">
                <label>X</label>
                <input type="number" [(ngModel)]="noktalar[koordinatDialogIndex].x" (ngModelChange)="noktaDegisti()" step="1" autofocus>
            </div>
            <div class="coord-row">
                <label>Y</label>
                <input type="number" [(ngModel)]="noktalar[koordinatDialogIndex].y" (ngModelChange)="noktaDegisti()" step="1">
            </div>
            <div class="coord-row">
                <label>Z</label>
                <input type="number" [(ngModel)]="noktalar[koordinatDialogIndex].z" (ngModelChange)="noktaDegisti()" step="1">
            </div>
        </div>
        <div class="koordinat-footer">
            <button class="btn-icon" [class.active]="noktaSecModu === koordinatDialogIndex"
                    (click)="noktaSecBaslat(koordinatDialogIndex)" title="3D'den seç">
                <i class="crosshairs icon"></i>
            </button>
            <button class="btn-icon btn-primary" (click)="koordinatDialogKapat()" title="Tamam">
                <i class="check icon"></i>
            </button>
        </div>
    </div>
</div>
}

<!-- Standalone Dialog (pencere olmadan kullanım için) -->
@if (gorunur && !pencere) {
<div class="polyline-dialog-standalone">
    <div class="dialog-header">
        <span>{{ duzenleModu ? 'Polyline Düzenle' : '3D Polyline' }}</span>
        <button class="close-btn" (click)="kapat()"><i class="close icon"></i></button>
    </div>
    <div class="dialog-content">
        <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
    </div>
</div>
}

<!-- FikoDialogService ile kullanım -->
@if (pencere) {
<ng-container *ngTemplateOutlet="dialogContent"></ng-container>
}
